export const DocumentTypeValues = {
  ACCOUNT_ENTRY: 'account-entry',
  RECONCILIATION_TEMPLATE: 'reconciliation-template',
  PERIOD_SPECIFIC_DOCUMENT: 'period-specific-document',
  PERMANENT_DOCUMENT: 'permanent-document',
  EXPORT: 'export',
} as const

export const PrefixMapping = {
  [DocumentTypeValues.ACCOUNT_ENTRY]: '#',
  [DocumentTypeValues.RECONCILIATION_TEMPLATE]: '!',
  [DocumentTypeValues.PERIOD_SPECIFIC_DOCUMENT]: '/',
  [DocumentTypeValues.PERMANENT_DOCUMENT]: '/',
  [DocumentTypeValues.EXPORT]: '/',
} as const

export type DocumentTypeValue =
  typeof DocumentTypeValues[keyof typeof DocumentTypeValues]

export const DocumentTypeTranslationKeys = {
  [DocumentTypeValues.ACCOUNT_ENTRY]:
    'components.document.existing_docs_modal.account_entry',
  [DocumentTypeValues.RECONCILIATION_TEMPLATE]:
    'components.document.existing_docs_modal.reconciliation_template',
  [DocumentTypeValues.PERIOD_SPECIFIC_DOCUMENT]:
    'components.document.existing_docs_modal.period_specific_document',
  [DocumentTypeValues.PERMANENT_DOCUMENT]:
    'components.document.existing_docs_modal.permanent_document',
  [DocumentTypeValues.EXPORT]: 'components.document.existing_docs_modal.export',
} as const

export const Steps = {
  TYPE_SELECTION: 'type-selection',
  DOCUMENT_LIST: 'document-list',
} as const

export type Step = typeof Steps[keyof typeof Steps]

export const CACHED_TYPES: DocumentTypeValue[] = [
  DocumentTypeValues.ACCOUNT_ENTRY,
  DocumentTypeValues.RECONCILIATION_TEMPLATE,
  DocumentTypeValues.EXPORT,
]
